module.exports = __webpack_public_path__ + "img/sf2.0de0534d.png";